<template>
    <div class="col-md-3 col-6">
        <div class="box p-a m-b"
             :class="stateToClass">
            <div class="app-monitor-icon m-l mt-3">
                <div v-html="stateToIcon"></div>
            </div>
            <div class="clear">
                <div class="text-u-c _600 text-xs text-muted">
                    <span v-if="custom_text">{{ custom_text | ucwords }}</span>
                    <span>{{ event_name | ucwords }} {{ event_type | ucwords }}{{ event_type.includes('call') ? 's' : '' }}</span>
                </div>
                <h4 class="m-0 text-xl _600">{{ count }}</h4>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'

    export default {
        props: {
            company_id: {
                required: false
            },
            custom_text: {
                required: false
            },
            event_name: {
                required: true
            },
            event_type: {
                required: true
            },
            event_interval: {
                required: true
            }
        },

        data() {
            return {
                auth: auth,
                loading: false,
                count: 0
            }
        },

        computed: {
            stateToClass() {
                // let state = this.event_name
                // if (state == 'abandoned' || state == 'missed') {
                //     return 'yellow-500'
                // } else if (state == 'failed') {
                //     return 'red-500'
                // }
                return 'light'
            },

            stateToIcon() {
                let type = this.event_type.includes('call') ? 1 : 2
                let direction = this.event_type.includes('inbound') ? 1 : 2
                let state = this.event_name
                let color = ''
                let icon = ''
                if (type === 1 || type === 3) {
                    if (state == 'in-progress') {
                        color = 'text-indigo-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">phone_in_talk</i>`
                    } else if (state == 'completed') {
                        color = 'text-green-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">call_end</i>`
                    } else if (state == 'abandoned') {
                        color = 'text-purple-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">phone_missed</i>`
                    } else if (state == 'forwarded') {
                        color = 'text-green-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">phone_forwarded</i>`
                    } else if (state == 'missed') {
                        color = 'text-red-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">phone_missed</i>`
                    } else if (state == 'failed') {
                        color = 'text-red-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">phone_locked</i>`
                    } else if (state == 'invalid') {
                        color = 'text-red-A400'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">phone_locked</i>`
                    } else if (state === 'dead-end') {
                        color = 'text-orange-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">block</i>`
                    } else {
                        icon += state
                    }
                } else if (type === 2) {
                    // if type is sms
                    if (state == 'in-progress') {
                        color = 'text-indigo-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">sms</i>`
                    } else if (state == 'completed') {
                        color = 'text-green-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">message</i>`
                    } else if (state == 'failed') {
                        color = 'text-red-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">sms</i>`
                    } else if (state == 'invalid') {
                        color = 'text-red-A400'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">sms</i>`
                    } else {
                        icon += state
                    }
                } else {
                    // if type is voicemail
                    if (state == 'in-progress') {
                        color = 'text-indigo-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">voicemail</i>`
                    } else if (state == 'completed') {
                        color = 'text-green-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">voicemail</i>`
                    } else if (state == 'failed') {
                        color = 'text-red-500'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">voicemail</i>`
                    } else if (state == 'invalid') {
                        color = 'text-red-A400'
                        icon += `<i class="text-2x m-y-sm material-icons ${color}">voicemail</i>`
                    } else {
                        icon += state
                    }
                }

                if (direction == 1) {
                    icon += `<i class="text-2x m-y-sm material-icons ${color}">call_received</i>`
                }

                if (direction == 2) {
                    icon += `<i class="text-2x m-y-sm material-icons ${color}">call_made</i>`
                }

                return icon
            }
        },

        created() {
            this.monitorEvent()
            // ping every 10 seconds
            this.$options.mointor_interval = setInterval(this.monitorEvent, 10000)
        },

        methods: {
            monitorEvent() {
                this.loading = true
                axios.get('/api/admin/monitor', {
                    params: {
                        event_name: this.event_name,
                        event_type: this.event_type,
                        interval: this.event_interval,
                        company_id: this.company_id
                    }
                }).then(res => {
                    this.count = res.data
                    this.loading = false
                }).catch(err => {
                    this.$root.handleErrors(err.response)
                    this.loading = false
                })
            }
        },

        beforeDestroy() {
            clearInterval(this.$options.mointor_interval)
        }
    }
</script>
